import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { trackEvent } from '@kcd/event-tracker';

import SegmentControlTab from '~/components/SegmentControlTab';
import {
  campaginDateRange,
  CAMPAIGN_DATE_TABS,
} from '~/domains/campaign/helper';
import { useRouterQueryByKey, useUpdateRouterQuery } from '~/hooks/url';

const { TODAY } = campaginDateRange;

export function CampaignDateFilter() {
  const router = useRouter();
  const campaignDate = useRouterQueryByKey('campaignDate', 'string');
  const [selectedTab, setSelectedTab] =
    useState<`${number}-${number}-${number}`>(
      (campaignDate as `${number}-${number}-${number}`) || TODAY,
    );

  const updateRouterQuery = useUpdateRouterQuery();

  const handleChangeTab = (date: `${number}-${number}-${number}`) => {
    setSelectedTab(date);
    void updateRouterQuery({ campaignDate: date });

    const name =
      CAMPAIGN_DATE_TABS.find((tab) => tab.id === date)?.content || '오늘';

    trackEvent('clicked tab in 마켓/캠페인 page', {
      path: window.location.pathname,
      name,
    });
  };

  useEffect(() => {
    const { date } = router.query;

    if (date && CAMPAIGN_DATE_TABS.some((tab) => tab.id === date)) {
      setSelectedTab(date as `${number}-${number}-${number}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <SegmentControlTab
      selectedTab={selectedTab}
      items={CAMPAIGN_DATE_TABS}
      onChange={handleChangeTab}
    />
  );
}
